export { GoogleCaptchaProvider, useCaptcha } from './GoogleCaptchaContext.web';
